import { render, staticRenderFns } from "./SentryManagement.vue?vue&type=template&id=bbf41abc&scoped=true"
import script from "./SentryManagement.vue?vue&type=script&lang=js"
export * from "./SentryManagement.vue?vue&type=script&lang=js"
import style0 from "./SentryManagement.vue?vue&type=style&index=0&id=bbf41abc&prod&lang=sass&scoped=true"
import style1 from "./SentryManagement.vue?vue&type=style&index=1&id=bbf41abc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf41abc",
  null
  
)

export default component.exports